/* ss-pin.js — la fascia resta ferma e il contenuto scorre di lato,
   poi la pagina riprende a scendere. Si spegne sotto le 3 schede
   e quando il sistema chiede meno animazioni. */
(function () {
  var sec = document.querySelector('[data-ss-pin]');
  if (!sec) return;
  var stick = sec.querySelector('.ss-pin__stick');
  var rail  = sec.querySelector('.ss-pin__rail');
  if (!stick || !rail) return;

  var cards = rail.children.length;
  var soft  = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (cards < 3 || soft) { sec.style.height = 'auto'; return; }
  sec.classList.add('is-pinned');

  var extra = 0, running = false;

  function misura() {
    extra = Math.max(0, rail.scrollWidth - stick.clientWidth + 40);
    sec.style.height = (window.innerHeight + extra) + 'px';
    muovi();
  }

  function muovi() {
    var r = sec.getBoundingClientRect();
    var p = Math.min(1, Math.max(0, -r.top / extra));
    rail.style.transform = 'translate3d(' + (-p * extra).toFixed(1) + 'px,0,0)';
    running = false;
  }

  window.addEventListener('scroll', function () {
    if (!running) { running = true; window.requestAnimationFrame(muovi); }
  }, { passive: true });
  window.addEventListener('resize', misura);
  if (document.readyState === 'complete') misura();
  else window.addEventListener('load', misura);
  misura();
})();
